import { authenticationReducers } from './authentication.reducers';
import { companyOverviewReducers } from './companyOverview.reducers';
import { homeReducers } from './home.reducers';
import { invoicesReducers } from './invoices.reducers';
import { loggingReducers } from "./logging.reducers";
import { registrationReducers } from "./registration.reducers";
import { userManagementReducers } from "./userManagement.reducers";

import authentication from '../slices/authentication.slices';
import userManagement from "../slices/userManagement.slices";
import logging from "../slices/logging.slices";

const rootReducer = {
    distributorPortal_authenticationReducers: authenticationReducers,
    distributorPortal_companyOverviewReducers: companyOverviewReducers,
    distributorPortal_homeReducers: homeReducers,
    distributorPortal_invoicesReducers: invoicesReducers,
    distributorPortal_loggingReducers: loggingReducers,
    distributorPortal_registrationReducers: registrationReducers,
    distributorPortal_userManagementReducers: userManagementReducers,

    distributorPortal_authentication: authentication,
    distributorPortal_userManagement: userManagement,
    distributorPortal_logging: logging,
};

export default rootReducer;